import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "../ui/tooltip";

const BAND_STYLES = {
  hot:      { bg: "bg-green-100 dark:bg-green-900/30", text: "text-green-700 dark:text-green-400", border: "border-green-300 dark:border-green-700" },
  warm:     { bg: "bg-amber-100 dark:bg-amber-900/30", text: "text-amber-700 dark:text-amber-400", border: "border-amber-300 dark:border-amber-700" },
  cold:     { bg: "bg-blue-100 dark:bg-blue-900/30", text: "text-blue-700 dark:text-blue-400", border: "border-blue-300 dark:border-blue-700" },
  inactive: { bg: "bg-gray-100 dark:bg-gray-800/30", text: "text-gray-500 dark:text-gray-400", border: "border-gray-300 dark:border-gray-700" },
};

export default function LeadScoreBadge({ score, band, size = "sm", showLabel = true }) {
  if (score == null || band == null) return null;

  const style = BAND_STYLES[band] || BAND_STYLES.inactive;
  const sizeClasses = size === "lg"
    ? "w-10 h-10 text-sm font-bold"
    : "w-7 h-7 text-xs font-semibold";

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <div className="flex items-center gap-1.5">
            <div className={`${sizeClasses} rounded-full flex items-center justify-center border ${style.bg} ${style.text} ${style.border}`}>
              {score}
            </div>
            {showLabel && (
              <span className={`text-xs font-medium capitalize ${style.text}`}>{band}</span>
            )}
          </div>
        </TooltipTrigger>
        <TooltipContent>
          <p>Lead Score: {score}/100 ({band})</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
